// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Payroll from "../../grpc/Payroll.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__Timestamp from "../../util/Timestamp.js";
import * as Buhta_components__LoadingDiv from "../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../packages/util/lib/DateTime.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as MelNumeral from "../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function PayoutPage(Props) {
  let org = Props.org;
  let id = Props.id;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const func = Buhta_cabinet__Payroll.PayoutService.view;
  const match$1 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._3(func, param, {
      hd: "employee",
      tl: /* [] */ 0
    }, id);
  }), undefined);
  const dispatch = match$1[1];
  const item = match$1[0];
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), [id]);
  let employeeData;
  if (typeof item === "string" || item.NAME !== "Data") {
    employeeData = {
      id: "",
      serial_id: 0,
      tin: "",
      family_name: "",
      given_name: "",
      patronymic_name: "",
      birthday_date: undefined,
      address: undefined,
      email: "",
      phone: "",
      create_time: undefined,
      update_time: undefined,
      employment: undefined
    };
  } else {
    const e = item.VAL.employee;
    employeeData = e !== undefined ? e : ({
        id: "",
        serial_id: 0,
        tin: "",
        family_name: "",
        given_name: "",
        patronymic_name: "",
        birthday_date: undefined,
        address: undefined,
        email: "",
        phone: "",
        create_time: undefined,
        update_time: undefined,
        employment: undefined
      });
  }
  let cardTransfer;
  if (typeof item === "string" || item.NAME !== "Data") {
    cardTransfer = {
      id: "",
      state: "",
      payout_txn_type: "",
      payout_txn_id: "",
      post_time: undefined,
      process_time: undefined,
      saved_card_id: "",
      card_number_six: "",
      card_number_four: "",
      card_issuer_network: undefined,
      card_issuer_bank: undefined,
      currency_code: /* CURRENCY_UNSPECIFIED */ 0,
      sent_amount: "",
      fee_amount: "",
      total_amount: "",
      cancel_time: undefined,
      cancel_reason_code: "",
      cancel_reason_message: "",
      payout_txn_refnum: ""
    };
  } else {
    const match$2 = item.VAL.destination_txn;
    cardTransfer = typeof match$2 === "string" ? ({
        id: "",
        state: "",
        payout_txn_type: "",
        payout_txn_id: "",
        post_time: undefined,
        process_time: undefined,
        saved_card_id: "",
        card_number_six: "",
        card_number_four: "",
        card_issuer_network: undefined,
        card_issuer_bank: undefined,
        currency_code: /* CURRENCY_UNSPECIFIED */ 0,
        sent_amount: "",
        fee_amount: "",
        total_amount: "",
        cancel_time: undefined,
        cancel_reason_code: "",
        cancel_reason_message: "",
        payout_txn_refnum: ""
      }) : match$2.VAL;
  }
  const fourDigits = cardTransfer.card_number_six.substring(0, 4);
  const remainingDigits = cardTransfer.card_number_six.substring(4, 6);
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
    title: "Выплаты"
  });
  let tmp;
  if (typeof item === "string") {
    tmp = item === "Loading" ? JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
  } else if (item.NAME === "Data") {
    const payout = item.VAL;
    const post_time = DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault(payout.post_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
    const match$3 = cardTransfer.state;
    let tmp$1;
    switch (match$3) {
      case "cancelled" :
        tmp$1 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              className: "w-12 h-12",
              alt: "pending-gray",
              src: StaticAsset.src("/static/icons/cancelled-state.svg")
            }),
            JsxRuntime.jsx("p", {
              children: payout.amount + (" " + "₸"),
              className: "text-4-5xl text-gray-medium font-bold"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Buhta_components__Text.P.make, {
                className: "text-gray-medium",
                children: "Отменен"
              }),
              className: "flex items-center"
            })
          ],
          className: "flex flex-col items-center gap-1"
        });
        break;
      case "failed" :
        tmp$1 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              className: "w-12 h-12",
              alt: "error-state",
              src: StaticAsset.src("/static/icons/error-state.svg")
            }),
            JsxRuntime.jsx("p", {
              children: payout.amount + (" " + "₸"),
              className: "text-4-5xl text-alert font-bold"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Buhta_components__Text.P.make, {
                className: "text-alert",
                children: "По карте получателя превышен лимит"
              }),
              className: "flex items-center"
            })
          ],
          className: "flex flex-col items-center gap-1"
        });
        break;
      case "processed" :
        tmp$1 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              className: "w-12 h-12",
              alt: "check-green",
              src: StaticAsset.src("/static/icons/check-green.svg")
            }),
            JsxRuntime.jsx("p", {
              children: MelNumeral.format({
                NAME: "Str",
                VAL: payout.amount
              }) + (" " + "₸"),
              className: "text-4-5xl text-success font-bold"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Buhta_components__Text.P.make, {
                className: "text-success",
                children: "Успешно"
              }),
              className: "flex items-center"
            })
          ],
          className: "flex flex-col items-center gap-1"
        });
        break;
      case "pending" :
      case "sent" :
        tmp$1 = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              className: "w-12 h-12",
              alt: "pending-gray",
              src: StaticAsset.src("/static/icons/pending-blue.svg")
            }),
            JsxRuntime.jsx("p", {
              children: payout.amount + (" " + "₸"),
              className: "text-4-5xl text-links font-bold"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Buhta_components__Text.P.make, {
                className: "text-links",
                children: "В обработке"
              }),
              className: "flex items-center"
            })
          ],
          className: "flex flex-col items-center gap-1"
        });
        break;
      default:
        tmp$1 = null;
    }
    const bank = cardTransfer.card_issuer_bank;
    let tmp$2;
    if (bank !== undefined) {
      tmp$2 = JsxRuntime.jsx("img", {
        className: "w-5 rounded-full",
        alt: bank.name,
        src: bank.icon_url
      });
    } else {
      const network = cardTransfer.card_issuer_network;
      tmp$2 = network !== undefined ? JsxRuntime.jsx("img", {
          className: "w-5 rounded-full",
          alt: network.icon_alt_url,
          src: network.icon_url
        }) : null;
    }
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
            route: contextRoute({
              TAG: /* Payroll */ 6,
              _0: {
                TAG: /* Payouts */ 1,
                _0: /* List */ 0
              }
            }),
            children: JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/close-20.svg")
            })
          }),
          className: "bg-white py-4.5 px-6 border-b border-gray-main w-full"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              tmp$1,
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-gray-medium",
                        children: "Номер платежа"
                      }),
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-black",
                        children: payout.document_num
                      })
                    ],
                    className: "flex justify-between"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-gray-medium",
                        children: "Cумма к получению"
                      }),
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-black",
                        children: payout.amount + (" " + "₸")
                      })
                    ],
                    className: "flex justify-between"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-gray-medium",
                        children: "На карту"
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          tmp$2,
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            className: "text-black",
                            children: fourDigits + (" " + (remainingDigits + ("•• •••• " + cardTransfer.card_number_four)))
                          })
                        ],
                        className: "flex items-center gap-2"
                      })
                    ],
                    className: "flex justify-between"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-gray-medium",
                        children: "ARN/RRN"
                      }),
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-black",
                        children: cardTransfer.payout_txn_refnum
                      })
                    ],
                    className: "flex justify-between"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-gray-medium",
                        children: "Дата"
                      }),
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-black",
                        children: post_time
                      })
                    ],
                    className: "flex justify-between"
                  })
                ],
                className: "flex flex-col gap-1"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("img", {
                          className: "h-16 w-16",
                          src: StaticAsset.src("/static/images/profile-80.jpg")
                        }),
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.P.make, {
                              className: "font-semibold w-56",
                              children: employeeData.family_name + (" " + (employeeData.given_name + (" " + employeeData.patronymic_name)))
                            }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "mt-1 text-default-gray",
                              children: "Менеджер продукта"
                            })
                          ],
                          className: "ml-6"
                        })
                      ],
                      className: "flex"
                    }),
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "w-35.25 text-default-gray",
                          children: "Телефон"
                        }),
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("img", {
                              className: "w-4 h-4",
                              src: StaticAsset.src("/static/icons/done-16.svg")
                            }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              children: Formating.formatPhone(employeeData.phone)
                            })
                          ],
                          className: "ml-4 flex items-center gap-1"
                        })
                      ],
                      className: "mt-6 flex"
                    }),
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "w-35.25 text-default-gray",
                          children: "Почта"
                        }),
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("img", {
                              className: "w-4 h-4",
                              src: StaticAsset.src("/static/icons/done-16.svg")
                            }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: " shrink-0",
                              children: employeeData.email
                            })
                          ],
                          className: "ml-4 flex items-center gap-1"
                        })
                      ],
                      className: "mt-1 flex"
                    }),
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "w-35.25 text-default-gray",
                          children: "ИИН"
                        }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "ml-4",
                          children: employeeData.tin
                        })
                      ],
                      className: "mt-1 flex"
                    }),
                    JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                      size: "s",
                      kind: "default",
                      className: "w-106 mt-6 py-2 px-4",
                      children: "Открыть профиль"
                    })
                  ]
                }),
                className: "border border-gray-main rounded-sm p-6 flex justify-between"
              })
            ],
            className: "flex flex-col gap-6"
          }),
          className: "bg-white w-140.5 mt-10 rounded-sm shadow-card p-10"
        })
      ],
      className: "w-full flex flex-col items-center"
    });
  } else {
    tmp = JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
  }
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: tmp,
    className: "bg-gray-pale"
  });
}

const make = PayoutPage;

export {
  make,
}
/* Buhta_cabinet__Button Not a pure module */
